import { jsxs as n, jsx as e } from "react/jsx-runtime";
import { Icon as a } from "../../../Icon/Icon.js";
import { c as i } from "../../../clsx-OuTLNxxd.js";
const c = "HilightedBadge-module_container__2s3PY",
  d = "HilightedBadge-module_status-not-chosen__dnZEH",
  r = "HilightedBadge-module_icon__UrZZ-",
  o = {
    container: c,
    statusNotChosen: d,
    icon: r
  },
  g = _ref => {
    let {
      children: t,
      status: s = "default"
    } = _ref;
    return /* @__PURE__ */n("div", {
      className: i(o.container, {
        [o.statusNotChosen]: s === "not-chosen"
      }),
      children: [/* @__PURE__ */e(a, {
        name: "star",
        padding: !1,
        className: o.icon
      }), " ", t]
    });
  };
export { g as HighlightedBadge };